import React from "react";
import { Productbtn } from "../../../../../../shared/services/interfacev2";
import { useImageFallback } from "../../hooks/useImageFallback";
import { useUser } from "src/shared/context/UserContext";
import { fontOptions, borderHighlightOptions } from "src/shared/modules/profile/theme/themeConstants";
import Image from "src/shared/Image";
import { useFormatAmount } from "../../hooks/useFormatAmount";

interface ProductCardProps {
  product: Productbtn;
  onSelect: (product: Productbtn) => void;
  isSelected?: boolean;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onSelect, isSelected }) => {
  const { imgSrc } = useImageFallback(product.imageUrl);
  const { user } = useUser();
  const formatAmount = useFormatAmount();

  const themeKey = user?.themes.backgroundColour || "DodgerBlue";
  const highlightClass = borderHighlightOptions[themeKey];
  const fontClass = fontOptions[user?.themes.fontFamily || "Sans-serif"];
  const truncateText = (text: any, length: number) => {
    const safeText = text ? String(text) : "";
    return safeText.length > length ? safeText.slice(0, length) + "..." : safeText;
  };
  return (
    <div
      className={`cursor-pointer p-2 rounded-2xl shadow-md hover:shadow-lg transition-all duration-200 bg-gray-50 border-2 min-h-[180px] h-auto self-start ${fontClass}
        ${isSelected ? `${highlightClass} ring-2` : "border-transparent"}`}
      onClick={() => onSelect(product)}
      id="product-button"
    >
      <div className="flex flex-col items-center w-full h-fit overflow-hidden rounded-lg mb-2 bg-white">
        <Image imagePath={imgSrc} className="w-[100px] h-[100px]" />
      </div>
      <div className="text-center text-black">
        <ul className="space-y-0.5">
          <li className="text-[13px] font-medium truncate leading-tight">{truncateText(product.productName, 35)}</li>
          <li className="text-[11px] text-gray-600 truncate">{truncateText(product.arabicName, 20)}</li>
        </ul>
        <p className="text-[14px] font-bold text-[#D70015] mt-1">{formatAmount(product.amount)}</p>
      </div>
    </div>
  );
};

export default ProductCard;
